import { defineComponent as _defineComponent } from 'vue'
import { CMap, getLocalization } from '@tokyojob/frontend-components'
import CVacancyDetailCard from '../c-vacancy-detail-cards/c-vacancy-detail-card.component.vue'
import { IVacancyLocationCard } from '../c-vacancy-detail-cards/interface/i-vacancy-location-card'
import { IVacancy, LocalizationData, LocalizationPath, VacancyGetters, WorkplaceGetters } from '@tokyojob/core'
import { PropType } from 'vue'
import { LocalizationService } from '@tokyojob/frontend-core'
import { getProvidedApp } from '~/base/utils/provided-getter'
import { VacancyDetailCardFactory } from '../c-vacancy-detail-cards/factory/vacancy-detail-card.factory'


export default /*#__PURE__*/_defineComponent({
  __name: 'c-vacancy-detail-location.component',
  props: {
  vacancy: {
    type: Object as PropType<IVacancy>,
    required: true
  }
},
  setup(__props) {

const props = __props;


const localization: LocalizationData = getLocalization(getProvidedApp())
const workplaceDetailsArray = VacancyGetters.workplaceDetails(props.vacancy)
const workplaceDetailsCard = VacancyDetailCardFactory.workplaceDetails(localization, workplaceDetailsArray)
const locationLabel = LocalizationService.t<string>(localization, LocalizationPath.LocationVacancyDetails)
const workplace = VacancyGetters.getWorkplace(props.vacancy)
const stationDistanceInformation = WorkplaceGetters.getStationDistanceInformation(workplace)
let vacancyLocationCard: IVacancyLocationCard | undefined
vacancyLocationCard = {
  locationName: VacancyGetters.getLocation(props.vacancy),
  coordinates: VacancyGetters.getCoordinates(props.vacancy),
  stationDistanceInformation
}

return { __sfc: true,props, localization, workplaceDetailsArray, workplaceDetailsCard, locationLabel, workplace, stationDistanceInformation, vacancyLocationCard, CMap, CVacancyDetailCard }
}

})